export default __webpack_public_path__ + "static/media/27.f6579df4.jpg";